import { render, staticRenderFns } from "./CreateAboutTheWard.vue?vue&type=template&id=7b98385f&scoped=true&"
import script from "./CreateAboutTheWard.vue?vue&type=script&lang=js&"
export * from "./CreateAboutTheWard.vue?vue&type=script&lang=js&"
import style0 from "./CreateAboutTheWard.vue?vue&type=style&index=0&id=7b98385f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b98385f",
  null
  
)

export default component.exports